'use client';

import { Portal, createListCollection, Select } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { CustomSelectProps, SelectChangeDetails, SelectOption } from 'types/common';

const CustomSelect: React.FC<CustomSelectProps> = ({
  options = [],
  value = [],
  onValueChange,
  inputStyle = {},
  placeholder = "Selecione uma opção"
}) => {
  const [selectValue, setSelectValue] = useState<string[]>(value);

  const itemsCollection = createListCollection({
    items: options
  });

  useEffect(() => {
    setSelectValue(value);
  }, [value]);

  const handleValueChange = (details: SelectChangeDetails) => {
    const selectedValue = details.value?.[0];
    const selectedOption = options.find(
      (option) => String(option.value) === String(selectedValue)
    );

    if (selectedOption?.isDisabled) {
      return;
    }

    setSelectValue(details.value);

    if (onValueChange) {
      onValueChange(details);
    }
  };

  return (
    <Select.Root
      collection={itemsCollection}
      value={selectValue}
      onValueChange={handleValueChange}
    >
      <Select.HiddenSelect />
      <Select.Control>
        <Select.Trigger {...inputStyle}>
          <Select.ValueText
            placeholder={placeholder}
            color={selectValue.length === 0 ? 'gray.400' : 'gray.800'}
          />
        </Select.Trigger>
        <Select.IndicatorGroup>
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Portal>
        <Select.Positioner transition="all 0.2s ease-in-out" _hover={{ bg: 'gray.100' }}>
          <Select.Content bg="white" color="black">
            {itemsCollection.items.map((item: SelectOption) => {
              const isDisabled = Boolean(item.isDisabled);

              return (
                <Select.Item
                  item={item}
                  key={item.value}
                  title={isDisabled ? item.disabledMessage : undefined}
                  transition="all 0.2s ease-in-out"
                  bg={isDisabled ? 'gray.50' : undefined}
                  color={isDisabled ? 'gray.400' : undefined}
                  cursor={isDisabled ? 'not-allowed' : 'pointer'}
                  _hover={isDisabled ? { bg: 'gray.50' } : { bg: 'gray.100' }}
                  _selected={
                    isDisabled
                      ? { bg: 'gray.50', color: 'gray.400', fontWeight: 'normal' }
                      : { bg: 'gray.100', color: 'green', fontWeight: 'bold' }
                  }
                  onPointerDown={
                    isDisabled
                      ? (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                      : undefined
                  }
                  onClick={
                    isDisabled
                      ? (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                      : undefined
                  }
                >
                  {item.label}
                  {!isDisabled && <Select.ItemIndicator />}
                </Select.Item>
              );
            })}
          </Select.Content>
        </Select.Positioner>
      </Portal>
    </Select.Root>
  );
};

export default CustomSelect;
